import { Route, Routes } from "react-router";
import { ReportType } from "../../../../api/types/svTypes.ts";
import SmartViewAppPage from "./SmartViewAppPage";
import TemplatesContainer from "./components/TemplatesContainer";
import EditTemplatePage from "./components/template/EditTemplatePage";
import TemplateRoot from "./components/template/TemplateRoot";
import { chartRelatedReportTypes } from "./utilities/chartRelatedReport.types.ts";

const supportedReportTypes = [...chartRelatedReportTypes, ReportType.Pivot, ReportType.Tabular];

const SmartViewTemplatePage = () => {
  return (
    <Routes>
      <Route element={<SmartViewAppPage supportedReportTypes={supportedReportTypes} />}>
        <Route element={<TemplatesContainer />}>
          <Route
            path={`:organization/:id/edit`}
            element={
              <TemplateRoot>
                <EditTemplatePage />
              </TemplateRoot>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default SmartViewTemplatePage;
